<div class="filter-container">
  <span class="title">{{ "generic.filter.filterBy" | translate }}</span>
  @for (item of singleFilters; track item) {
    <a (click)="selectFilter(item)" [ngClass]="{ selected: item.selected }">
      {{ getPlaceholder(item.placeholder) | translate: getArgsOfPlaceholder(item.placeholder) }}
    </a>
  }
  @if (arrayFilters.length && singleFilters.length) {
    <span class="divider">|</span>
  }
  @for (filterItem of arrayFilters; track filterItem; let i = $index) {
    <div id="list-options-filter" class="dropdown-div">
      <mat-select
        id="list-options-filter-select"
        (selectionChange)="selectArrayFilter($event)"
        class="dropdown-select"
        [ngClass]="{ selected: selectedValue(filterItem).value !== null }"
        [value]="selectedValue(filterItem)">
        @for (item of filterItem; track item) {
          <mat-option [value]="item">
            {{ getPlaceholder(item.placeholder) | translate: getArgsOfPlaceholder(item.placeholder) }}
          </mat-option>
        }
      </mat-select>
    </div>
  }
  @if (arrayGroupBy.length && (arrayFilters.length || singleFilters.length)) {
    <span class="divider">|</span>
  }
  @if (arrayGroupBy.length) {
    <span class="title">{{ "generic.filter.groupBy" | translate }}</span>
    @for (filterItem of arrayGroupBy; track filterItem; let i = $index) {
      <div class="dropdown-div">
        <mat-select
          (selectionChange)="selectArrayFilter($event)"
          class="dropdown-select"
          [ngClass]="{ selected: selectedValue(filterItem).value !== null }"
          [value]="selectedValue(filterItem)">
          @for (item of filterItem; track item) {
            <mat-option [value]="item">
              {{ (typeof item.placeholder === 'string' ? item.placeholder : item.placeholder?.key) | translate }}
            </mat-option>
          }
        </mat-select>
      </div>
    }
  }
  @if ((arrayGroupBy.length || arrayFilters.length || singleFilters.length) && sortBy.length) {
    <span class="divider">|</span>
  }
  @if (sortBy.length) {
    <span class="title">{{ "generic.filter.sortBy" | translate }}</span>
    @for (item of sortBy; track item) {
      <a (click)="selectSort(item)" [class.selected]="item.value">
        {{ getPlaceholder(item.placeholder) | translate: getArgsOfPlaceholder(item.placeholder) }}
        @if (item.value) {
          <fa-icon [icon]="item.value === 'ASC' ? 'chevron-up' : 'chevron-down'"></fa-icon>
        }
      </a>
    }
  }
</div>
